import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 19.8.",
  "description": "",
  "published": "2011-08-19T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-19-8/swizec/2263"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/photo1-300x224.jpg",
        "alt": null,
        "title": "It's an Android!"
      }}></img></p>
    <p>{`Today I learned that the Google Store isn't publicly accessible. Didn't expect this at all, but I'm glad I know someone from Google and could buy some crap I don't actually need anyway. But those plushies are so fucking fluffy I'm gonna die! (that was a reference by the way, did you catch it?)`}</p>
    <p>{`Another thing I learned is that I have zero knowledge about how memory management works in node.js. Had a process misbehaving today that looked like there was a huge memory leak. The damn thing was wasting something like 400 megs of RAM without doing anything.`}</p>
    <p>{`Started exploring and trying to figure out what could be leaking ... voila, boom, memory use drops to normal levels. I even tried some experiments that I was certain would produce memory leaks (leaving references to scopes inside closures and so on) and nothing I tried wanted to produce a memory leak.`}</p>
    <p>{`And no matter what I tried the server process just wouldn't do anything stupid again. I should look into this more.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      